require('../polyfills');
require('../main-aot');
console.info(`🌳 Greenplease
AoT build`);
